import TeacherSelector from './src/main';

/* istanbul ignore next */
TeacherSelector.install = function(Vue) {
  Vue.component(TeacherSelector.name, TeacherSelector);
};

export default TeacherSelector;
